import { CalendarJobTitleDto, CalendarUserFilterRs } from '@domain/rs/calendar/CalendarUserFilterRs';
import { BusinessSizeType } from '@domain/constant/businessSize';
import { RecruitCategoryType } from '@domain/constant/recruitCategoryType';

export class CalendarUserFilterVO {
  jobTitles: CalendarJobTitleDto[];
  recruitmentTypes: RecruitCategoryType[];
  businessSizeTypes: BusinessSizeType[];
  locations: number[];

  constructor(rs: CalendarUserFilterRs) {
    this.jobTitles = rs.jobTitles.map((jobTitle) => new CalendarJobTitleVO(jobTitle));
    this.recruitmentTypes = rs.recruitmentTypes;
    this.businessSizeTypes = rs.businessSizeTypes;
    this.locations = rs.locations;
  }
}

export class CalendarJobTitleVO {
  code: number;
  name: string;

  constructor(dto: CalendarJobTitleDto) {
    this.code = dto.code;
    this.name = dto.name;
  }
}
